import { BUNNY_CDN, BunnyVideo } from '@/components/media';
import type { EventSlug, TourEvent } from '@/features/events';
import styles from './VslInline.module.css';

/* =============================================================================
 * EL VSL DE CADA CIUDAD · material del cliente del 12-sep-2026,
 * REEMPLAZADO DOS VECES, LA ÚLTIMA POR LA TERCERA ENTREGA DEL 23-sep-2026
 * -----------------------------------------------------------------------------
 * Tercera entrega («VSL# NUEVOS VIDEOS», 23-sep-2026, por la noche): otros cinco
 * montajes (Buenos Aires 141 s, Bogotá 190, México 158, Cancún 212; el de Miami
 * también llegó, y se retiró de la web con su destino el 29-sep-2026)
 * y, aparte, una PORTADA por ciudad («GIRA <CIUDAD>.jpeg»), que se subió como
 * miniatura de cada vídeo en Bunny. El reproductor pinta esa miniatura como
 * `poster`, así que es lo que se ve antes de darle a play.
 * Las dos entregas anteriores se BORRARON de la librería (750890) a petición
 * del cliente; no hay vuelta atrás a ellas.
 * -----------------------------------------------------------------------------
 * «he terminado de editar estos 5 vídeos». Cinco piezas de 3 a 5 minutos, una
 * por destino: Azrahel hablando a cámara desde su estudio de podcast, con
 * música. Es un VSL —un argumentario de venta en su propia voz—, no relleno.
 *
 * VA INCRUSTADO EN EL HERO, ENCIMA DE LA PROMESA, Y SIN BOTÓN QUE LO ABRA.
 * Instrucciones literales del ORACLE (12-sep-2026): «dije de poner el vídeo VSL
 * en el home, sin botón para abrirlo» y «debería ir arriba del texto rompe el
 * motor». El reproductor ES la pieza.
 *
 * DOS INTENTOS ANTERIORES, LOS DOS MÍOS Y LOS DOS EQUIVOCADOS, que se dejan
 * escritos porque la lección vale más que la apariencia de acertar siempre:
 *   1. Botón en la banda de CTA que sigue al programa. Medido en la página ya
 *      publicada: 2.827 px del borde, el 38 % del alto, tres pantallas de
 *      scroll. El propio cliente no lo encontraba.
 *   2. Botón en el hero, que arreglaba la visibilidad pero seguía siendo un
 *      botón: un clic de más entre el visitante y el argumento de venta.
 * La lección: la posición y la forma de una pieza se MIDEN sobre la página real
 * y se contrastan con lo que pidió quien la encarga, no se deducen del árbol de
 * secciones.
 *
 * NO ARRANCA SOLO, Y NO ES UN OLVIDO. Sin un clic previo en la página no hay
 * gesto del usuario, y ningún navegador deja sonar un vídeo sin gesto. La única
 * alternativa sería silenciarlo, y esto es alguien HABLANDO: sin voz no hay VSL.
 * Se pinta el fotograma de portada con los controles, que es honesto.
 *
 * CANCÚN LLEVA LOS DOS, y esto lo corrigió el ORACLE: su VSL incrustado como
 * las otras cuatro, Y el vídeo de la convivencia anterior en Palmaïa detrás de
 * su botón, que es como lo pidió el cliente («añadas un botón ... que lleve a la
 * visualización de este vídeo»). Son dos piezas distintas: una explica el retiro
 * y la otra ENSEÑA el hotel donde se duerme y se cena.
 * ========================================================================== */

interface Vsl {
  /** GUID en la librería de Bunny Stream `EventoAzrahel` (750890). */
  readonly bunnyId: string;
  /**
   * La portada que entregó el cliente, subida como miniatura del vídeo. Bunny
   * le pone un nombre con hash y deja de servir `thumbnail.jpg` (da 404), así
   * que el nombre va aquí tal cual lo devuelve su API (`thumbnailFileName`).
   */
  readonly portada: string;
  /** Qué se ve, para quien no puede verlo. */
  readonly descripcion: string;
}

/**
 * `Partial` a propósito: una ciudad sin VSL no rompe nada, simplemente no pinta
 * el botón. Así el día que el cliente entregue el de Cancún —o retire uno— el
 * cambio es una línea de este mapa y ninguna página se entera.
 */
/* RETIRADOS POR EL CLIENTE EL 27-oct-2026 («quitar todos los vídeos de
 * presentación que hay en cada ciudad. Los voy a dejar de momento sin vídeo de
 * presentación»), al cambiar otra vez las fechas de la gira. Los GUID y portadas
 * de los cuatro VSL siguen en Bunny y en el historial de este fichero. */
const VSL_POR_CIUDAD: Partial<Record<EventSlug, Vsl>> = {};

export interface VslInlineProps {
  event: TourEvent;
}

/**
 * El VSL de la ciudad, incrustado. `null` si esa ciudad no tiene vídeo.
 *
 * SE COLOCA COMO HERMANO DEL TEXTO DEL HERO, NUNCA DENTRO DEL BLOQUE DEL BOTÓN.
 * Ahí dentro heredaba el ancho de un flex que se encoge a su contenido y el
 * vídeo salía a 290 px en Buenos Aires y 478 en Bogotá: un sello de correos, y
 * de un tamaño distinto en cada ciudad. Como hermano del titular coge el ancho
 * del bloque de texto, que es el que manda en la composición.
 */
export function VslInline({ event }: VslInlineProps) {
  const vsl = VSL_POR_CIUDAD[event.slug];
  if (!vsl) return null;

  return (
    <div className={styles.marco}>
      <BunnyVideo
        videoId={vsl.bunnyId}
        description={vsl.descripcion}
        poster={`https://${BUNNY_CDN}/${vsl.bunnyId}/${vsl.portada}`}
        className={styles.video}
      />
    </div>
  );
}
